import { utcToJSDate } from "@/utils/date-time";
import { BaseLookupModel, LatLng, PaginationFilterRequest } from "./core.model";
import { City } from "./city.model";
import { RunEventDistanceTypeEnum } from "./run-event-distance.model";
import { EventLink } from "./event-link.model";

export function scrapedEventFromJson<T extends ScrapedEvent>(json: any): T {
  return {
    ...json,
    registrationDate: utcToJSDate(json.registrationDate),
    startDate: utcToJSDate(json.startDate),
    distances: json.distances?.map((d: any) => ({ ...d, startDate: utcToJSDate(d.startDate) })),
  } as T;
};

export interface ScrapedEvent {
    id: number;
    name: string;
    description?: string;
    cityId?: number;
    cityName?: string;
    countryId?: number;
    countryName: string;
    imageUrl?: string;
    registrationDate: Date;
    startDate: Date;
    sourceWebsiteUrl?: string;
    sourceId?: string;
    source: ScrapSourceEnum;
    eventType?: EventTypeEnum;
    isApproved: boolean;
    path: LatLng[];
    distances?: ScrapedEventDistance[];
    links?: EventLink[];

    city?: City
    country?: BaseLookupModel
}

export interface ScrapedEventDistance {
    name?: string;
    distanceInMeter?: number;
    startDate?: Date;
}

export interface ApproveScrapedDistance {
    startDate: Date;
    type: RunEventDistanceTypeEnum;
    distance?: number; // meters
    path?: LatLng[];
}

export interface UpdateScrapedEvent {
    id?: number;
    cityId?: number;
    countryId?: number;
    eventType?: EventTypeEnum;
}

export class ScrapedEventPaginationFilterRequest extends PaginationFilterRequest{  
    cityId?: number;
    countryId?: number;
    source?: ScrapSourceEnum;
    eventType?: EventTypeEnum;
    isApproved?: boolean;
}

export enum ScrapSourceEnum 
{
    CheckPointSpot = 1,
    Ahuto = 2,
    WorldsMarathons = 3,
    HKJogging = 4,
    PaoBaoDao = 5,
}
export const ScrapSourceList =  
[
  {value: 1, label: "Check Point Spot", url: "https://www.checkpointspot.asia"},
  {value: 2, label: "Ahuto", url: "https://www.ahotu.com"},
  {value: 3, label: "Worlds Marathons", url: "https://worldsmarathons.com"},
  {value: 4, label: "HK Jogging", url: "https://www.hkjogging.com"},
  {value: 5, label: "PaoBaoDao", url: "https://www.paobaodao.com"}
];

export enum EventTypeEnum 
{
  Marathon = 1,
  RunEvent = 2,
  Trail = 3,
  Hyrox = 4,
}
export const EventTypeList =  
[
  {value: 1, label: "Marathon"},
  {value: 2, label: "Run Event"},
  {value: 3, label: "Trail"},
  {value: 4, label: "Hyrox"}
];


export interface ApproveScrapedEvent {
  scrapedEventId: number;
  eventType: EventTypeEnum;
  marathon?: ApproveScrapedMarathon;
  runEvent?: ApproveScrapedRunEvent;
};

export interface ApproveScrapedMarathon {
    name?: string;
    description?: string;
    cityId?: number;
    countryId?: number;
    imageUrl?: string;
    website?: string;
    marathonKeyId?: number;
    registrationDate?: Date;
    isMajorMarathon?: boolean;

    startDate?: Date;
    marathonDistanceType?: RunEventDistanceTypeEnum;    
    path?: LatLng[];
    distances?: ApproveScrapedDistance[];
    links?: EventLink[];
}

export interface ApproveScrapedRunEvent {
    name?: string;
    description?: string;
    cityId?: number;
    imageUrl?: string;
    website?: string;
    registrationDate?: Date;

    startDate?: Date;
    distance?: number;
    path?: LatLng[];
    distances?: ApproveScrapedDistance[];
    links?: EventLink[];
}